// Warns players on browsers other than Chrome or Safari — camera capture,
// face-swap uploads, and the canvas-based image processing across the
// photobooth flow are the most likely to behave inconsistently elsewhere
// (older Android WebViews, in-app browsers, etc.).

const SESSION_FLAG = 'unsupportedBrowserWarningShown';

export function isSupportedBrowser(userAgent = navigator.userAgent || '') {
  const ua = userAgent;
  // Chromium-based browsers other than Chrome itself (Edge, Opera, Samsung
  // Internet, Brave, ...) all still say "Chrome" in their UA string, so
  // they have to be excluded explicitly rather than just matching "Chrome".
  const isChrome = /Chrome|CriOS/.test(ua) && !/Edg\/|EdgA\/|EdgiOS\/|OPR\/|SamsungBrowser|Brave/.test(ua);
  const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|Chromium|Android/.test(ua);
  return isChrome || isSafari;
}

/** Shows a one-time-per-session warning popup if the current browser isn't Chrome/Safari. */
export function warnIfUnsupportedBrowser(Swal) {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  if (isSupportedBrowser()) return;

  try {
    if (sessionStorage.getItem(SESSION_FLAG)) return;
    sessionStorage.setItem(SESSION_FLAG, 'true');
  } catch {
    // Ignore storage errors (e.g. private-browsing restrictions) — worst
    // case the warning shows more than once, which is harmless.
  }

  Swal.fire({
    title: 'Unsupported Browser',
    text: 'For the best experience, please use Google Chrome or Safari. Some features (like camera capture) may not work correctly in this browser.',
    icon: 'warning',
    confirmButtonText: 'Continue anyway',
  });
}
